import { useEffect } from 'react'
import { useTheme } from './ThemeProvider'

export const WORKSPACE_SHELL_THEME_CLASS = {
  light: 'theme-gtm',
  dark: 'theme-gtm-dark',
} as const

/**
 * The signed-in workspace (MainLayout) uses the Laplace design system in the
 * viewer's own light/dark choice. It is set once for the whole shell, on
 * `<html>` so portals (dialogs, sheets, menus) match, instead of per page:
 * otherwise the sidebar flips palette whenever a route opts in or out.
 */
export function useWorkspaceShellTheme() {
  const { resolvedTheme } = useTheme()

  useEffect(() => {
    const root = window.document.documentElement
    const themeClass = WORKSPACE_SHELL_THEME_CLASS[resolvedTheme]
    root.classList.add(themeClass)

    return () => root.classList.remove(themeClass)
  }, [resolvedTheme])
}
